<template>
  <div id="app" v-cloak>
    <router-view/>
  </div>
</template>

<script>
	export default {}
</script>

<style>
	.loader-container {
		text-align: center;
	    padding-top: 20vh;
	    margin: 20px 0;
	    font-size: 40px;
	}
	.text-center { text-align: center;  }
	.simple-table {
	  border: 1px solid #ccc;
	  border-collapse: collapse;
	  table-layout: fixed;
	  width: 100%;
	}
	.simple-table caption {
	  font-size: 1.5em;
	  margin: .5em 0 .75em;
	}
	.simple-table tr {
	  border: 1px solid #ddd;
	  padding: .35em;
	}
	.simple-table tr:nth-child(even) {
	  background: #f8f8f8;
	}
	.simple-table th,
	.simple-table td {
	  padding: .625em;
	  text-align: left;
	  padding-top: 1.2em;
	  padding-bottom: 1.2em;
	}
	.simple-table th {
	  background: #999;
	  color: #fff;
	  font-size: .85em;
	  letter-spacing: .1em;
	  text-transform: uppercase;
	}
	.simple-table td {
	  white-space: nowrap;
	  overflow: hidden;
	  text-overflow: ellipsis;
	  font-size: 1.2em;
	}
</style>